CalendarSettingsView = require 'views/power-ups/calendar-settings-view'
CardAgingSettingsView = require 'views/power-ups/card-aging-settings-view'
LegacyPowerUps = require 'data/legacy-power-ups'
VotingSettingsView = require 'views/power-ups/voting-settings-view'

module.exports = [
  name: 'voting'
  author: 'Trello Inc'
  iconUrl: require 'images/powerups/voting-icon.svg'
  settingsView: (model) -> new VotingSettingsView({ model })
  aboutTemplate: 'power_ups_about_voting'
  screenshots: [require('images/powerups/voting/screenshots/2015-3-23-screenshot1.png')]
  id: LegacyPowerUps.voting
,
  name: 'cardAging'
  author: 'Trello Inc'
  iconUrl: require 'images/powerups/card-aging-icon.svg'
  settingsView: (model) -> new CardAgingSettingsView({ model })
  aboutTemplate: 'power_ups_about_card_aging'
  screenshots: [require('images/powerups/card-aging/screenshots/2015-3-23-screenshot1.png')]
  id: LegacyPowerUps.cardAging
,
  name: 'calendar'
  author: 'Trello Inc'
  iconUrl: require 'images/powerups/calendar-icon.svg'
  settingsView: (model) -> new CalendarSettingsView({ model })
  aboutTemplate: 'power_ups_about_calendar'
  screenshots: [require('images/powerups/calendar/screenshots/2015-3-23-screenshot1.png')]
  id: LegacyPowerUps.calendar
]



// WEBPACK FOOTER //
// ./app/scripts/views/directory/directory-legacy-power-ups.coffee